<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form class="container-fluid justify-content-start">
            <div>
              <p>รหัสการเเลกสินค้า</p>
            </div>

            <p style="margin-left: auto">{{ reward._id }}</p>

            <div class="line-c">
              <hr class="new4" />
            </div>
          </form>
        </nav>
      </div>
      <div class="row bg-white s">
        <div>
          <img
            class="img-profile"
            :src="'https://api.loyaltyhub.me/public/' + reward.rewardId.image"
            v-if="reward.rewardId.image != ''"
          />

          <span class="name-now">{{ rewardDate }} น.</span>
          <br /><span class="name-Product">{{ reward.reward_name }}</span>
          <br />
          <img
            class="iconpoint"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-bottom-navigation-01-reward-active.png"
          />
          <span class="name-price">{{ reward.point  | numFormat('0,000,000') }} คะแนน</span>
        </div>
      </div>
      <div
        v-if="reward.shipping_address.name != '' || reward.shipping_address !== undefined"
      >
        <div>
          <span class="wordorder">จัดส่ง</span>
        </div>
        <div class="det">
          <br /> <!--<img
            class="iconthree"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-pin.png"
          /> -->
          <!-- <span class="name-company"
            >บริษัท loyalty hub<br />
            203 พระราม 2 บางมด จอมทอง กรุงเทพมหานคร 10150</span
          >

          <br / -->
          <img
            class="iconthreet"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-pin-red.png"
          />
          <span class="name-cutumer"
            >{{ reward.shipping_name }}<br />
            {{ reward.shipping_phone }}<br />
            {{ reward.shipping_address }}</span
          >
        </div>

        <div class="det" v-if="reward.tracking_information !== undefined ">
          <img
            class="iconthreet"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-pin-red.png"
          />
          <span class="name-cutumer"
            >{{ reward.tracking_information.company }}<br />
            {{ reward.tracking_information.tracking_code }}<br />
            {{ reward.tracking_information.tracking_date }}
            </span
          >
        </div>
      </div>
    </body>
  </html>
</template>
<script>
import { DateTimeFunc } from "../libs/constant.js";
import Navbar from "./navbar";
export default {
  name: "",
  components: {
    navbar: Navbar,
  },
  data() {
    return {};
  },
  computed: {
    reward() {
      return this.$store.state.redeem.history.filter((item) => { return item.status == "Approved";})[this.$route.params.rewardIndex || 0];
    },
    rewardDate() {
      return DateTimeFunc.reformatDate(this.reward.createdAt);
    },
  },
  mounted() {
    console.log(this.$route);
    // console.log(this.$router);
    console.log(this.reward);
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.name-company {
  color: #7f8285a9;
  font-size: 13px;
  padding: 5px 5px 5px 10px;
}

.name-cutumer {
      font-family: 'Prompt';
  color: #7f8285a9;
  font-size: 13px;
  padding: 5px 5px 5px 10px;
}
.name-locat {
      font-family: 'Prompt';
  color: #7f828596;
  margin-top: 50px;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.det {
  margin-top: -43px;
  padding: 5px 15px 15px 15px;
}
.iconthreet {
  display: block;
  margin-right: 3px;
  margin-top: 11px;
  float: left;
}
.icon-t {
  display: block;
  margin-left: 3px;
  margin-right: 16px;
  margin-top: -6px;
  float: left;
}
.iconpoint {
  display: block;
  margin-left: 16px;
  margin-right: -14px;
  margin-top: 7px;
  width: 27px;
  height: 27px;
  float: left;
  padding: 3px 3px 3px 3px;
}
hr.new4 {
  border: 1px solid #848484;
  height: 1px;
  border-radius: 73px;
}
.line-c {
  display: table;
  top: 34px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  border-radius: 30px;
  left: 0px;
}
.line-d {
  display: table;
  top: 34px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 211px;
  right: 40px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
  float: left;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: 50px;
}
.btn-outline-success {
      font-family: 'Prompt';
  color: #7f8285;
  border-color: #963c3c00;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
}
.btn-outline-secondary {
      font-family: 'Prompt';
  color: #7bc79a;
  border-color: #ffffff00;
  font-weight: bold;
  width: 100%;
  float: left;
  font-size: 19px;
}
.navbar {
  color: #ffffff;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
      font-family: 'Prompt';
  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background-color: #fff0 !important;
}
.bg-white.s {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
  top: -6px;
}
.bg-white.ss {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}
p {
    font-size: 13px;
    color: #7f8285;
    text-align: center;
    margin-left: -54px;
    margin-top: 7px;
}
.img-profile{
    display: block;
    width: 124px;
    height: 125px;
    float: left;
    margin-left: -15px;
    left: 0px;
    border-radius: 0;
        margin-top: 0px;
}
.name-status {
      font-family: 'Prompt';
  color: #7bc79a;
  margin-top: 13px;
  font-size: 16.3px;
  font-weight: bold;
}
.name-now {
      font-family: 'Prompt';
  color: #585858cb;
  margin-top: 13px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {
      font-family: 'Prompt';
  color: #7bc79a;
  margin-top: 3px;
  font-size: 21px;
  padding: 0px 0px 0px 21px;
}
.name-Product {
      font-family: 'Prompt';
  color: #000000;
  font-size: 14px;
  padding: 2px 2px 15px 21px;
}
.wordorder {
      font-family: 'Prompt';
  color: #000000;
  margin-top: 3px;
  font-size: 16px;
  padding: 0px 0px 0px 21px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
</style>
